export enum NrSpaApiEnum {
    ERROR,
    PAGE_ACTION,
    SET_NAME,
    SET_NAME_SAVE
}
